import { render } from "./contentLanguange.vue?vue&type=template&id=6fba8a4e&scoped=true"
import script from "./contentLanguange.vue?vue&type=script&lang=js"
export * from "./contentLanguange.vue?vue&type=script&lang=js"

import "./contentLanguange.vue?vue&type=style&index=0&id=6fba8a4e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fba8a4e"]])

export default __exports__